import { tv } from 'tailwind-variants'

export const carouselStyles = tv({
  slots: {
    container: 'flex w-full max-w-full flex-col',
    buttonGroup: 'flex hidden w-full flex-row gap-x-12 pt-6 lg:flex',
    itemContainer: 'h-full',
  },
  variants: {
    alignArrows: {
      center: {
        buttonGroup: 'justify-center',
      },
      left: {
        buttonGroup: 'justify-start',
      },
      right: {
        buttonGroup: 'justify-end',
      },
    },
    variant: {
      products: {
        itemContainer: 'products_carousel',
      },
      default: {
        itemContainer: '',
      },
    },
  },
})
